import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, FormGroup, Input, Button, Spinner } from "reactstrap";
import { enqueueSnackbar } from "notistack";
import { uploadCouncils } from "../../services/ValitanApiService";

const CouncilsUploadModal = ({ isOpen, toggle, loadCouncils, paginationInfo }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false); // Loading state

    const handleFileChange = (event) => {
        const file = event.target.files ? event.target.files[0] : null;
        setSelectedFile(file);
    };

    const handleFileUpload = async (event) => {
        event.preventDefault();

        if (!selectedFile) {
            enqueueSnackbar("No file selected.", { variant: 'error' });
            return;
        }

        // file size check
        if (selectedFile.size > 10 * 1024 * 1024) { // 10MB file size limit
            enqueueSnackbar("File size exceeds the 10MB limit.", { variant: 'error' });
            return;
        }

        setIsUploading(true); // Start loading

        try {
            const formData = new FormData();
            formData.append('file', selectedFile);

            const response = await uploadCouncils(formData);
            console.log('Response status code:', response.status)
            if (response.status === 200) {
                enqueueSnackbar("Success...", { variant: 'success' });
                loadCouncils(paginationInfo.pageNumber, paginationInfo.pageSize);
                toggle(); // Close modal
                setSelectedFile(null); // Clear file input
            } else {
                enqueueSnackbar("Failed...", { variant: 'error' });
            }

        }  finally {
            setIsUploading(false); // Stop loading
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop={"static"}>
            <ModalHeader toggle={toggle}>Upload Councils</ModalHeader>
            <ModalBody>
                <form onSubmit={handleFileUpload}>
                    <FormGroup>
                        <Input
                            type="file"
                            name="file"
                            id="fileUpload"
                            onChange={handleFileChange}
                            accept=".xlsx, .xls"
                        />
                    </FormGroup>
                    <Button
                        type="submit"
                        color="primary"
                        className="float-end"
                        disabled={isUploading || !selectedFile} // Disable if uploading or no file
                    >
                        {isUploading ? <Spinner size="sm" /> : "Upload"} {/* Loading spinner */}
                    </Button>
                </form>
            </ModalBody>
        </Modal>
    );
};

export default CouncilsUploadModal;
